import { create } from 'zustand';
import { useNotificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { CardsApi, RequestStrategyEnum, type AddCardRequest } from '@shared/api';
import { Constants } from '@shared/widgets';

interface UseAddCardStore {
  loading: boolean;
  error: string | null;
  addCard: (request: AddCardRequest, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useAddCardStore = create<UseAddCardStore>((set) => ({
  loading: false,
  error: null,

  addCard: ApiUtils.wrapperApi(async (request, signal) => {
    try {
      set({ loading: true, error: null });
      await CardsApi.addCard(request, signal);
      set({ loading: false });
      useNotificationStore.getState().setSuccess(Constants.DEFAULT_SUCCESS_MESSAGE);
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
      useNotificationStore.getState().setError(Constants.DEFAULT_ERROR_MESSAGE);
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, error: null }),
}));
